import * as amplitude from "@amplitude/analytics-browser"
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser"
import { getMetaVar } from "~/common/getMetaVar"

let enabled = false

// Amplitude buffers calls made before init() forever, so every call site checks
// this first — without an API key (local dev, test) tracking is a no-op.
export const isAmplitudeEnabled = () => enabled

export const initAmplitude = () => {
  const apiKey = getMetaVar("amplitude-api-key")

  if (!apiKey) {
    return
  }

  amplitude.add(sessionReplayPlugin({ sampleRate: 1 }))

  amplitude.init(apiKey, {
    // Lets the project's Amplitude settings (autocapture toggles, sampling)
    // be changed from their dashboard without a deploy.
    fetchRemoteConfig: true,
    // Page views, clicks, form interactions, sessions, and file downloads.
    autocapture: true,
  })

  enabled = true
}
